import _ from 'lodash';

const filterUtils = {

  filterUser(testString, user) {
    // or userTemplates
    var userString = "";
    userString += user.username;
    userString += user.firstName;
    userString += user.lastName;
    userString += user.handle;
    userString += user.firstName;
    userString += user.handle;
    userString += user.username;
    userString += user.handle;
    userString += user.firstName;
    userString += user.username;
    userString += user.lastName;

    userString = userString.replace(/[^a-zA-Z0-9]/g,'');
    return userString.toLowerCase().indexOf(testString) > -1;
  }

  , filterResourceLink(testString, resourceLink) {
    let resourceString = resourceLink.url + resourceLink.name;
    resourceString = resourceString.replace(/[^a-zA-Z0-9]/g,'')
    return resourceString.toLowerCase().indexOf(testString.toLowerCase()) > -1;
  }

  , filterStudyUser(testString, studyUser, userMap) {
    let studyUserParams = studyUser.email.toLowerCase().trim().split(" ");
    if(studyUser.siteNumber && studyUser.siteNumber.length > 0) {
      studyUserParams.push(studyUser.siteNumber.toLowerCase().trim());
    }
    studyUserParams.push(studyUser.status.toLowerCase().trim());
    if(userMap[studyUser._user] && userMap[studyUser._user].firstName) {
      studyUserParams.push(userMap[studyUser._user].firstName.toLowerCase().trim());
      studyUserParams.push(userMap[studyUser._user].lastName.toLowerCase().trim());
    }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let studyUserParam of studyUserParams) {
        if(studyUserParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterSite(testString, site, sponsors, studies) {
    const selectedSponsor = (
      sponsors && sponsors.length > 0
    ) ?
        sponsors.filter(sponsor => sponsor._id === site._organization)[0]
      : sponsors._id ?
        sponsors
      :
        null;
    const selectedStudy = (
      studies && studies.length > 0
    ) ?
        studies.filter(study => study._id === site._group)[0]
      : studies._id ?
        studies
      :
        null;
    let siteParams = site.name.toLowerCase().trim().split(" ");
    siteParams.push(site.number.toLowerCase().trim());
    if(selectedSponsor) {
      siteParams.push(selectedSponsor.name.toLowerCase().trim());
    }
    if(selectedStudy) {
      siteParams.push(selectedStudy.name.toLowerCase().trim());
    }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let siteParam of siteParams) {
        if(siteParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterMyStudies(testString, study) {
    let studyParams = study.name.toLowerCase().trim().split(" ");

    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let studyParam of studyParams) {
        if(studyParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterStudy(testString, study, sponsorList) {

    let studyParams = study.name.toLowerCase().trim().split(" ");
    const selectedSponsor = sponsorList.filter(sponsor => sponsor._id === study._organization);
    if(selectedSponsor.length > 0) {
      studyParams.push(selectedSponsor[0].name.toLowerCase().trim());
    }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let studyParam of studyParams) {
        if(studyParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterModuleCert(testString, moduleCert, tmMap) {
    let moduleCertParams = moduleCert.status.toLowerCase().trim().split(" ");
    const selectedCM = tmMap[moduleCert._contentModule]
    // const selectedCM = tmList.filter(tm => tm._id === moduleCert._contentModule);
    if(selectedCM) {
      moduleCertParams.push(selectedCM.title.toLowerCase().trim());
      moduleCertParams.push(selectedCM._id);
      
    }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let moduleCertParam of moduleCertParams) {
        if(moduleCertParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterEvaluation(testString, evaluation, sponsorList) {
    let evaluationParams = evaluation.title.toLowerCase().trim().split(" ");
    // const selectedSponsor = sponsorList.filter(sponsor => sponsor._id === evaluation._organization);
    // if(selectedSponsor.length > 0) {
    //   evaluationParams.push(selectedSponsor[0].name.toLowerCase().trim());
    // }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let evaluationParam of evaluationParams) {
        if(evaluationParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterCertificateTemplate(testString, certificateTemplate, sponsorList) {
    let certificateTemplateParams = certificateTemplate.name.toLowerCase().trim().split(" ");
    // const selectedSponsor = sponsorList.filter(sponsor => sponsor._id === certificateTemplate._organization);
    // if(selectedSponsor.length > 0) {
    //   certificateTemplateParams.push(selectedSponsor[0].name.toLowerCase().trim());
    // }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let certificateTemplateParam of certificateTemplateParams) {
        if(certificateTemplateParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterCourse(testString, course, sponsorList, studyList) {
    let courseParams = course.title.toLowerCase().trim().split(" ");
    const selectedSponsor = sponsorList.filter(sponsor => sponsor._id === course._organization);
    const selectedStudy = studyList.filter(study => study._id === course._group);
    if(selectedSponsor.length > 0) {
      courseParams.push(selectedSponsor[0].name.toLowerCase().trim());
    }
    if(selectedStudy.length > 0) {
      courseParams.push(selectedStudy[0].name.toLowerCase().trim());
    }
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let courseParam of courseParams) {
        if(courseParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterContentModule(testString, contentModule) {
    let contentModuleParams = contentModule.title.toLowerCase().trim().split(" ");
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let contentModuleParam of contentModuleParams) {
        if(contentModuleParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }


  , filterSponsor(testString, sponsor) {
    let sponsorParams = sponsor.name.toLowerCase().trim().split(" ");
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let sponsorParam of sponsorParams) {
        if(sponsorParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , filterSiteLocation(testString, siteLocation) {
    let siteLocationParams = siteLocation.name.toLowerCase().trim().split(" ");
    
    // siteLocationParams.push(siteLocation.descriptioon.toLowerCase().trim().split(" ")); // probably unneccessary
    if(siteLocation && siteLocation.address) {
      siteLocationParams.push(siteLocation.address.street1.toLowerCase().trim());
      siteLocationParams.push(siteLocation.address.city.toLowerCase().trim());
      siteLocationParams.push(siteLocation.address.state.toLowerCase().trim());
      siteLocationParams.push(siteLocation.address.postal.toLowerCase().trim());
      siteLocationParams.push(siteLocation.address.country.toLowerCase().trim());
    }
    
    const searchParams = testString.toLowerCase().trim().split(" ");
    let match = true;
    for(let searchParam of searchParams) {
      let innerMatch = false;
      for(let siteLocationParam of siteLocationParams) {
        if(siteLocationParam.replace(/[^a-zA-Z0-9]/g,'').indexOf(searchParam.replace(/[^a-zA-Z0-9]/g,'')) > -1) {
          innerMatch = true;
        }
      }
      if(!innerMatch) {
        match = false;
      }
    }
    return testString.length == 0 || match;
  }

  , sortByOrderWeight(array) {
    // sort primarily by order weight.  if order weights equal, sort by created
    return _.orderBy(array, ['orderWeight', 'created'], ['asc', 'asc']);
  }

  , randomizeOrder(array) {
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm in ES6
     */
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array
  }

}

export default filterUtils;



// WEBPACK FOOTER //
// global/utils/filterUtils.js